<template>
    <div class="content-body todo-list">
        <el-table
                :data="dataList"
                v-loading="dataListLoading"
                size="small"
                stripe
                @selection-change="selectionChangeHandle"
                :height="documentClientHeight"
                style="width: 100%;">
            <el-table-column
                    type="index"
                    width="50"
                    label="序号">
            </el-table-column>
            <el-table-column
                    prop="taskName"
                    header-align="left"
                    align="left"
                    label="名称">
            </el-table-column>
            <el-table-column
                    prop="processName"
                    header-align="left"
                    align="left"
                    label="相关流程">
            </el-table-column>
            <el-table-column
                    prop="createTime"
                    header-align="left"
                    align="left"
                    label="创建时间">
            </el-table-column>
            <el-table-column
                    header-align="left"
                    align="left"
                    width="300"
                    label="操作">
                <template>
                    <el-button type="text" size="small" @click="executeHandle()" icon="el-icon-edit">处理
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
                @size-change="sizeChangeHandle"
                @current-change="currentChangeHandle"
                :current-page="pageIndex"
                :page-sizes="[10, 20, 50]"
                :page-size="pageSize"
                :total="totalPage"
                layout="total, sizes, prev, pager, next, jumper">
        </el-pagination>
    </div>
</template>

<script>
    import { fetchTodoList } from '@/controller/workflow'
    export default {
        data() {
            return {
                documentClientHeight: document.documentElement['clientHeight'] - 250,
                dataForm: {
                    code: '',
                    name: ''
                },
                dataList: [],
                pageIndex: 1,
                pageSize: 10,
                totalPage: 0,
                dataListLoading: false,
                dataListSelections: [],
                addOrUpdateVisible: false,
                menuUpdateVisible: false
            }
        },
        components: {
        },
        activated() {
            this.listTenants()
        },
        methods: {
            executeHandle() {
              this.$router.push('/portal-basicInfo')
            },
            // 获取数据列表
            listTenants() {
                this.dataListLoading = true
                fetchTodoList(
                    {
                        'pageNo': this.pageIndex,
                        'pageSize': this.pageSize,
                        'operatorId': 'supplier001'
                    }
                ).then(data => {
                    if (data && data.code === '00') {
                        this.dataList = data.body.records
                        this.totalPage = data.body.total
                    } else {
                        this.dataList = []
                        this.totalPage = 0
                    }
                    this.dataListLoading = false
                })
            },
            // 每页数
            sizeChangeHandle(val) {
                this.pageSize = val
                this.pageIndex = 1
                this.listTenants()
            },
            // 当前页
            currentChangeHandle(val) {
                this.pageIndex = val
                this.listTenants()
            },
            // 多选
            selectionChangeHandle(val) {
                this.dataListSelections = val
            },
            // 新增 / 修改
            addOrUpdateHandle(id) {
                this.addOrUpdateVisible = true
                this.$nextTick(() => {
                    this.$refs.addOrUpdate.init(id)
                })
            },
            menuUpdateHandle(id) {
                this.menuUpdateVisible = true
                this.$nextTick(() => {
                    this.$refs.menuUpdate.init(id)
                })
            }
        }
    }
</script>